import { i18n } from 'i18next';
import i18nConfig from '../translations/i18n';
import { RoleType } from '../types/role-type';
import { translations } from '../types/translations';

export const getI18n = (): i18n => {
  return i18nConfig;
};

export async function translateToLanguage(languageCode: string) {
  getI18n().changeLanguage(languageCode);
}

export function getRoleLabel(roleType: RoleType): string {
  const I18N = getI18n();

  switch (roleType) {
    case RoleType.OptelAdmin:
      return I18N.t(translations.RoleTypeOptelAdmin);

    case RoleType.OptelSupport:
      return I18N.t(translations.RoleTypeOptelSupport);

    case RoleType.TenantAdmin:
      return I18N.t(translations.RoleTypeTenantAdmin);

    case RoleType.Operator:
      return I18N.t(translations.RoleTypeOperator);

    case RoleType.Viewer:
      return I18N.t(translations.RoleTypeViewer);

    case RoleType.Unknown:
      return I18N.t(translations.RoleTypeUnknown);
      
    default:
      return '';
  }
}



// WEBPACK FOOTER //
// ./src/services/i18n-service.ts